// Filters on the Blog SEO list pages (parts/Blog SEO "Glossary" and "Crowdfunding tracker"): the glossary's search field and letter
// pills, and the tracker's platform and status chips. Without JavaScript every card shows and the tools stay hidden.

// A glossary card shows under the picked letter ("all" for every letter) when its term contains the search words.
export function termShows(card, letter, query) {
  const words = String(query ?? '').trim().toLowerCase();
  return (letter === 'all' || card.letter === letter) && (!words || String(card.text ?? '').includes(words));
}

// A tracker row shows under the picked chip when one of its keys (platform, status) is that chip.
export function rowShows(keys, picked) {
  return picked === 'all' || keys.includes(picked);
}

if (typeof document !== 'undefined') {
  const press = (group, button, attribute) => {
    for (const other of group.querySelectorAll(`button[${attribute}]`)) other.setAttribute('aria-pressed', String(other === button));
  };
  for (const root of document.querySelectorAll('[data-ns-glossary]')) {
    const tools = root.querySelector('[data-ns-glossary-tools]');
    if (!tools) continue;
    tools.hidden = false;
    const search = tools.querySelector('[data-ns-glossary-search]');
    let letter = 'all';
    const apply = () => {
      let any = false;
      for (const card of root.querySelectorAll('[data-term]')) {
        const show = termShows({ letter: card.getAttribute('data-letter'), text: card.getAttribute('data-term') }, letter, search?.value);
        card.hidden = !show;
        any ||= show;
      }
      const none = root.querySelector('[data-ns-glossary-none]');
      if (none) none.hidden = any;
    };
    tools.addEventListener('click', event => {
      const button = event.target.closest('button[data-letter]');
      if (!button) return;
      letter = button.getAttribute('data-letter');
      press(tools, button, 'data-letter');
      apply();
    });
    search?.addEventListener('input', apply);
  }
  for (const root of document.querySelectorAll('[data-ns-filter-root]')) {
    const chips = root.querySelector('[data-ns-filters]');
    if (!chips) continue;
    chips.hidden = false;
    chips.addEventListener('click', event => {
      const button = event.target.closest('button[data-filter]');
      if (!button) return;
      const picked = button.getAttribute('data-filter');
      press(chips, button, 'data-filter');
      let any = false;
      for (const row of root.querySelectorAll('[data-keys]')) {
        row.hidden = !rowShows(row.getAttribute('data-keys').split(' '), picked);
        any ||= !row.hidden;
      }
      const none = root.querySelector('[data-ns-filter-none]');
      if (none) none.hidden = any;
    });
  }
}
